import React, {useEffect, useRef, Suspense, lazy} from 'react';
import {Router, Route, Switch} from 'react-router-dom';
import {SnackbarProvider} from 'notistack';
import history from './Services/history';
import settings from './settings';
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {useDispatch} from 'react-redux'
import {setAuth, setDrawerState, setFocus, setInitialUserLanguage} from "./app/app.slice";
import request from "./Services/API/Requests";
//material
import {IconButton, Icon, CssBaseline, makeStyles} from "@material-ui/core";
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
// import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module'
import AppWrapper from "./app/AppWrapper";
import {ConfirmationProvider} from "./Components/JsonScreen/Utils/Confirmation/ConfirmContextProvider";
import {PopupProvider} from "./Components/JsonScreen/PopupScreen/PopupContextProvider";
import ConfirmDialog from "./Components/JsonScreen/Utils/Confirmation/ConfirmDialog";
import PopupScreenWithHook from "./Components/JsonScreen/PopupScreen/PopupScreenWithHook";
import {setSession} from "./Components/JsonScreen/jsonScreen.slice";
import {Loading} from "./Utils/Loading/Loading";
import {SocketProvider} from "./Services/Socket/SocketProvider";
import config from 'config'
import './App.css';
import ApplicationsList from "./Components/ApplicationBuilder/ApplicationList/ApplicationsList";
import ApplicationDesigner from "./Components/ApplicationBuilder/ApplicationDesigner/ApplicationDesigner";
import UploadAvatarComponent
    from "./Components/JsonScreen/Screen/ScreenComponents/UploadAvatarPopupComponent/UploadAvatarComponent";

const theme = createMuiTheme({
    palette: {
        primary: {
            500: '#007DC4'
        },
        //primary: settings.theme.primaryColor.import,
        secondary: settings.theme.secondaryColor.import,
        type: settings.theme.type
    },
    typography: {
        useNextVariants: true,
        suppressDeprecationWarnings: true,
        fontFamily: config.themeFont,
        button: {
            textTransform: "none"
        }
    }
});

const SchemaDesigner = lazy(() => import('./Components/SchemaDesigner'));
const MenuDesigner = lazy(() => import('./Components/MenuDesignerNew'));
const DmnActions = lazy(() => import('./Components/Dmn/DmnActions'));
const BpmnActions = lazy(() => import('./Components/Bpmn/BpmnActions'));
const BpmnView = lazy(() => import('./Components/Bpmn/BpmnView'));
const ScreenDesignerNew = lazy(() => import('./Components/ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner'));
const ListDesigner = lazy(() => import('./Components/ListDesigner'));
const NoComponent = lazy(() => import('./Components/NoComponent/NoComponent'));
const DataSourceDesigner = lazy(() => import('./Components/DataSource/DataSource'));
const useStyles = makeStyles(() => ({
    layout: {
        overflowY: 'hidden',
        height: 'inherit'
    }
}));

const App = () => {
    const myRef = useRef();
    const notistackRef = useRef();
    const dispatch = useDispatch();
    const classes = useStyles();

    useEffect(() => {
        const node = myRef.current;
        node && node.addEventListener("keydown", (e) => {
            if (e.altKey && e.code === 'Digit1') {
                dispatch(setFocus('sidebar'));
            }
            if (e.altKey && e.code === 'Digit2') {
                dispatch(setFocus('content'));
            }
            if (e.altKey && e.code === 'Digit3') {
                dispatch(setFocus('header'))
            }
            if (e.altKey && e.code === 'KeyT') {
                history.push('/core/taskList');
                dispatch(setFocus('content'))
            }
        });

        async function getUserInfo() {
            try {
                dispatch(setInitialUserLanguage());
                const res = await request({
                    url: "/user/getUserInfo",
                    data: {}
                })
                if (!res) {
                    dispatch(setAuth(false))
                    return;
                }
                if (res.user.id === 'anonymous') {
                    dispatch(setAuth(false))
                    return
                }

                dispatch(setSession({key: 'user', value: res}))
                dispatch(setAuth(true))
                dispatch(setDrawerState(true));
            } catch (error) {
                console.log(error)
                dispatch(setAuth(false))
            }
        }

        // function init_ga() {
        //     try {
        //         console.log('init ga')
        //         ReactGA.initialize(config.ga_key)
        //     } catch (e) {
        //         console.log('init ga error', e)
        //     }
        // }

        function init_gtm() {
            try {
                console.log('init gtm');
                TagManager.initialize({gtmId: config.gtm_key})
            } catch (e) {

            }

        }

        //
        // if (config && config.ga_key) {
        //     // init_ga();
        // }

        if (config && config.gtm_key) {
            init_gtm();
        }

        getUserInfo();
    }, []);

    return (
        <Router history={history}>
            <SocketProvider>
                <MuiThemeProvider theme={theme}>
                    <SnackbarProvider
                        maxSnack={4}
                        ref={notistackRef}
                        action={(key) => (
                            <IconButton onClick={() => notistackRef.current.closeSnackbar(key)} style={{padding: 5}}>
                                <Icon fontSize={"small"} style={{color: "#fff"}}>close</Icon>
                            </IconButton>
                        )}
                    >
                        <PopupProvider>
                            <ConfirmationProvider>
                                <DndProvider backend={HTML5Backend}>
                                    <div ref={myRef} className={classes.layout}>
                                        <CssBaseline/>
                                        <Suspense fallback={<Loading/>}>
                                            <Switch>
                                                <Route exact path={"/:app/screenDesigner/:id?"}
                                                       component={ScreenDesignerNew}/>

                                                <Route path={"/schemaDesigner/:id?"}
                                                       component={SchemaDesigner}/>
                                                <Route path={"/:app/app-list"}
                                                       component={ApplicationsList}
                                                />
                                                <Route path={"/:app/app-builder/:id"}
                                                       component={ApplicationDesigner}
                                                />
                                                <Route path={"/:app/schemaDesigner/:id?"}
                                                       component={SchemaDesigner}/>

                                                <Route path={"/:app/menuDesigner/:id?"}
                                                       component={MenuDesigner}/>

                                                <Route path={"/:app/menuDesigner/:id?"}
                                                       component={MenuDesigner}/>

                                                <Route path={"/:app/listDesigner/:id?"}
                                                       component={ListDesigner}/>

                                                <Route path={"/:app/dataSourceDesigner/:id?"}
                                                       component={DataSourceDesigner}/>

                                                <Route exact path="/:app/bpmn/edit/:id?"
                                                       component={BpmnActions}/>

                                                <Route exact path="/:app/bpmn/view/:id?"
                                                       component={BpmnView}/>

                                                <Route exact path="/:app/dmn/edit/:id?"
                                                       component={DmnActions}/>

                                                <Route exact path="/:app/:name?/:id?/:screenInfo?"
                                                       component={AppWrapper}/>
                                                <Route component={NoComponent}/>
                                            </Switch>
                                        </Suspense>
                                    </div>
                                </DndProvider>
                                <ConfirmDialog/>
                                <PopupScreenWithHook/>
                                <UploadAvatarComponent/>
                            </ConfirmationProvider>
                        </PopupProvider>
                    </SnackbarProvider>
                </MuiThemeProvider>
            </SocketProvider>
        </Router>

    )
};

export default App;
